<template>
    <div>
        <sign-in></sign-in>
        <!-- <h1>学分模块</h1> -->
    </div>
</template>
<script>

// config
import appConfig from '../../appConfig';

import signIn from '../me/signIn.vue'

import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

export default {
    data(){
        return{
            title:'签到'

        }
    },
    components:{
        signIn,
    },
    methods:{
          setWechatShare : function()
        {
            let wechatShareOptions = {
                title   : appHelper.getTitle(),
                // desc    : this.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        },
    },
    mounted(){
        appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat)
        {
            this.setWechatShare();
        }

    },
}
</script>
<style lang="scss" scoped>

</style>
